import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'rr-segment-control-item',
  standalone: false,
  templateUrl: './segment-control-item.component.html',
  styleUrl: './segment-control-item.component.scss'
})
export class SegmentControlItemComponent {
  @Input() size: string | undefined;
  @Input() icon: string | undefined;
  @Input() name: string | undefined;
  @Output() clicked = new EventEmitter<void>();
  isActive = false;
  isHover = false;
  isPress = false;
  isFocus = false;

  @HostListener('click') onClick() {
    this.clicked.emit();
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.isHover = true;
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.isHover = false;
    this.isPress = false;
  }

  @HostListener('mousedown') onMouseDown() {
    this.isPress = true;
  }

  @HostListener('mouseup') onMouseUp() {
    this.isPress = false;
  }

  @HostListener('focus') onFocus() {
    this.isFocus = true;
  }

  @HostListener('blur') onBlur() {
    this.isFocus = false;
  }
}
